import * as m from "motion/react-m";
import type { FC } from "react";
import { useTranslation } from "react-i18next";

/**
 * Thinking indicator component shown when AI is processing
 */
export const ThinkingIndicator: FC = () => {
  const { t } = useTranslation("ai-chat");
  return (
    <m.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 10 }}
      className="mx-auto w-full max-w-[var(--thread-max-width)] px-2 py-4"
    >
      <div className="flex items-center gap-3 text-muted-foreground">
        <div className="flex gap-1">
          <m.div
            className="h-2 w-2 rounded-full bg-muted-foreground"
            animate={{
              scale: [1, 1.2, 1],
              opacity: [0.5, 1, 0.5],
            }}
            transition={{
              duration: 1,
              repeat: Number.POSITIVE_INFINITY,
              delay: 0,
            }}
          />
          <m.div
            className="h-2 w-2 rounded-full bg-muted-foreground"
            animate={{
              scale: [1, 1.2, 1],
              opacity: [0.5, 1, 0.5],
            }}
            transition={{
              duration: 1,
              repeat: Number.POSITIVE_INFINITY,
              delay: 0.2,
            }}
          />
          <m.div
            className="h-2 w-2 rounded-full bg-muted-foreground"
            animate={{
              scale: [1, 1.2, 1],
              opacity: [0.5, 1, 0.5],
            }}
            transition={{
              duration: 1,
              repeat: Number.POSITIVE_INFINITY,
              delay: 0.4,
            }}
          />
        </div>
        <span className="text-sm">{t("thread.thinking")}</span>
      </div>
    </m.div>
  );
};
